import { newPasswordFromReset, resetPassword } from '../../api/cognitoWithAwsSdk';

interface IProps {
  render: (state: {
    newPasswordFromReset: typeof newPasswordFromReset;
    resetPassword: typeof resetPassword;
  }) => any;
}

// This allows us to contain all the aws-sdk imports and load them async for code splitting.
export const CognitoUtils = ({ render }: IProps) => render({ newPasswordFromReset, resetPassword });
